import { FC, useEffect } from 'react'
import { Box, SelectChangeEvent, Typography } from '@mui/material'

/* Utils */
import { CPITimePeriod } from '../../../../models'

/* Components */
import { InsightsTimePickerChipsWrapper } from './insightsTimePicker.styles'
import TimePickerCustomSelectField from './TimePickerCustomSelectField'

interface Props {
  timePeriodValues: Array<CPITimePeriod | string>
  selectedTimePeriod: CPITimePeriod | string
  handleChangeTimePeriod: (event: SelectChangeEvent | null, customPayload?: any) => void
  checkTimePeriodDisabled: () => boolean
  customTimePeriodValue: string
  hideSelected?: boolean
  disabled?: boolean
  anchorEl: any
  closeCustomPicker: any
  handleCustomClick: any
  setAnchorEl: any
  maxWidth?: string
}

const InsightsTimePicker: FC<Props> = ({
  timePeriodValues,
  selectedTimePeriod,
  handleChangeTimePeriod,
  checkTimePeriodDisabled,
  customTimePeriodValue,
  hideSelected,
  disabled,
  anchorEl,
  closeCustomPicker,
  maxWidth,
  handleCustomClick,
  setAnchorEl
}) => {
  useEffect(() => {
    if (!anchorEl) {
      closeCustomPicker()
    }
  }, [anchorEl])

  return (
    <InsightsTimePickerChipsWrapper className="chips-container time-period">
      <Box className="select-field-wrapper">
        <Typography className="chips-title">Time</Typography>
        <TimePickerCustomSelectField
          options={timePeriodValues}
          label=""
          placeholder=""
          maxWidth={maxWidth}
          labeltext="All Time"
          value={selectedTimePeriod}
          handleChange={handleChangeTimePeriod}
          disabled={checkTimePeriodDisabled() || Boolean(disabled)}
          handleCustomClick={handleCustomClick}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          closeCustomPicker={closeCustomPicker}
          customTimePeriodValue={customTimePeriodValue}
          hideSelected={hideSelected}
        />
      </Box>
    </InsightsTimePickerChipsWrapper>
  )
}

export default InsightsTimePicker
